import { makeSelectors } from "../../core/make-selectors";
import { BookInfo } from "./types";

const baseSelectors = makeSelectors<BookInfo>("bookInfo");

export const getBookInfo = baseSelectors.getData;
export const getBookInfoStatus = baseSelectors.getFetchStatus;
export const getBookInfoResultStatusCode = baseSelectors.getResultStatusCode;
